export default __webpack_public_path__ + "static/media/transfer-send-step5.046277a1.png";